<template>
  <div class="config_main_manage_page_wraper config_action_list">
    <div class="config_main_manage_page_content">
      <config-title-hang>
        <span slot="config_title_hang_ele2">{{ productTitle }}</span>
      </config-title-hang>

      <config-hang v-for="scene in sceneList" :key="scene.sceneId"
        :button-hang-ele5-completed="Boolean(completedScenes[scene.sceneId])">
        <span slot="config_hang_ele2_1">{{ scene.sceneName }}</span>
        <span slot="config_hang_ele2_2">场景号：{{ scene.sceneNo }}，规则数：{{ scene.ruleCount }}</span>
        <span v-if="scene.ruleCount > 0" slot="config_button_hang_ele5" @click.stop="confirmResend(scene)">
          {{ sceneButtonText(scene) }}
        </span>
        <span v-else slot="config_hang_ele3">无规则</span>
      </config-hang>

      <div v-if="!loading && sceneList.length === 0" class="xiaotishi_style">
        {{ isAllScenes ? '当前账号没有可展示的场景。' : '当前产品没有关联场景。' }}
      </div>
      <div class="xiaotishi_style">提示：{{ warningMessage }}</div>

      <confirm-dialog :visible="Boolean(pendingScene)" :title="confirmTitle"
        :message="warningMessage"
        confirm-text="确认补发" @cancel="pendingScene = null" @confirm="resendScene" />
    </div>
  </div>
</template>

<script>
import configHang from 'components/common/config/config-hang'
import configTitleHang from 'components/common/config/config-title-hang'
import confirmDialog from 'components/common/confirm-dialog/confirm-dialog'

export default {
  components: { configHang, configTitleHang, confirmDialog },
  data () {
    return {
      loading: false,
      loadingSceneId: '',
      pendingScene: null,
      sceneList: [],
      // 仅帮助用户记忆本次页面操作，刷新或离开页面后不保留。
      completedScenes: {}
    }
  },
  computed: {
    productTitle () {
      return this.isAllScenes
        ? '全部场景补发'
        : (this.$route.query.productName || this.$route.query.remark || '当前产品') + '关联场景补发'
    },
    isAllScenes () {
      return this.$route.query.scope === 'ALL'
    },
    warningMessage () {
      return '场景补发可能涉及多个产品，请确保关联产品全部在线后，再进行此操作。同一场景仅需在替换全部产品后补发一次即可。'
    },
    confirmTitle () {
      return this.pendingScene ? `确认补发“${this.pendingScene.sceneName}”吗？` : '确认补发场景吗？'
    }
  },
  created () {
    this.loadSceneList()
  },
  methods: {
    loadSceneList () {
      this.loading = true
      this.$request({
        method: 'post',
        url: this.isAllScenes ? '/userScene/findAllSceneResendList' : '/userScene/findProductSceneResendList',
        data: this.isAllScenes
          ? { token: this.$store.state.token }
          : { token: this.$store.state.token, productId: this.$route.query.productId }
      }).then(res => {
        if (res.data.code !== 0) {
          this.$showTipsToast(3, res.data.message)
          return
        }
        this.sceneList = res.data.data || []
      }).catch(error => console.log(error)).finally(() => {
        this.loading = false
      })
    },
    confirmResend (scene) {
      if (!this.loadingSceneId && scene.ruleCount > 0 && !this.completedScenes[scene.sceneId]) {
        this.pendingScene = scene
      }
    },
    resendScene () {
      const scene = this.pendingScene
      if (!scene) return
      this.pendingScene = null
      this.loadingSceneId = scene.sceneId
      const timeout = scene.ruleCount * 600 + 6000
      this.$store.dispatch('asyUpdataRequestSceneTimeout', timeout)
      this.$requestSceneRule({
        method: 'post',
        url: '/userScene/resendScene',
        timeout: timeout,
        data: { token: this.$store.state.token, sceneId: scene.sceneId }
      }).then(res => {
        if (res.data.code !== 0) {
          this.$showTipsToast(3, res.data.message)
        } else if ((res.data.data || []).length === 0) {
          this.$set(this.completedScenes, scene.sceneId, true)
          this.$showTipsToast(1, scene.sceneName + '补发成功', true)
        } else {
          this.$showTipsToast(7, res.data.data)
        }
      }).catch(error => {
        this.$showTipsToast(3, error.message || '场景补发失败')
      }).finally(() => {
        this.loadingSceneId = ''
      })
    },
    sceneButtonText (scene) {
      if (this.loadingSceneId === scene.sceneId) return '补发中'
      if (this.completedScenes[scene.sceneId]) return '已完成'
      return scene.ruleCount > 0 ? '补发' : '无规则'
    }
  }
}
</script>
